import { useClient } from "../context";

export function useProvider() {
  const client = useClient()
  return client.data?.provider
}